interface SweetAlertOptions {
  cancelButtonText: string;
  closeOnConfirm: boolean;
  confirmButtonText: string;
  customClass: string;
  showCancelButton: boolean;
  text: string;
  title: string;
  type: string;
}

interface OptionsArguments {
  closeOnConfirm?: boolean;
  showCancelButton?: boolean;
  thingToDelete?: string;
}

export const deleteOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: t("Cancel"),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: t("Delete"),
  customClass: 'deleting',
  showCancelButton: argument?.showCancelButton ?? true,
  text: `${t("Are you sure you want to delete")} ${argument?.thingToDelete ?? ''}?`,
  title: t("Really?"),
  type: "warning",
});

export const unsavedChangesOptions = (argument?: OptionsArguments): SweetAlertOptions => ({
  cancelButtonText: t("Continue Editing"),
  closeOnConfirm: argument?.closeOnConfirm ?? true,
  confirmButtonText: t("Discard and Close"),
  customClass: "unsaved-changes",
  showCancelButton: argument?.showCancelButton ?? true,
  text: t("Are you sure you want to discard changes?"),
  title: t("Unsaved Changes"),
  type: "warning",
});
